export enum SubscriptionSuccessEnum {
	CREATE = 'Create',
	UPDATE = 'Update'
}
